export default __webpack_public_path__ + "static/media/endividamento.7a240325.svg";